import { createFileRoute } from '@tanstack/react-router'

import { parseAuditSearch } from '@/components/audit/audit-search-schema'
import { AuditWorkspace } from '@/components/audit/audit-workspace'

export const Route = createFileRoute('/_app/audit')({
  validateSearch: parseAuditSearch,
  component: AuditPage,
})

function AuditPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <AuditWorkspace
      search={search}
      onSearchChange={(next) => {
        void navigate({ search: (current) => ({ ...current, ...next }) })
      }}
    />
  )
}
